export class ActionMessage {
    message: string | undefined;
    messageType: ActionMessageType | undefined;
}

export enum ActionMessageType {
    Info = 0,
    Success = 1,
    Warning = 2,
    Failure = 3
}
